import { POST_MESSAGE_TARGET_ORIGIN } from "shared/consts";

export const sendPostMessage = (message: any) => {
  if (!window?.parent) return;
  if (import.meta.env.VITE_SHOW_SNAPSHOT !== false) {
    console.log('sendPostMessage', message);
  }
  window.parent.postMessage(message, POST_MESSAGE_TARGET_ORIGIN)
}